import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { ReportAction } from "../actions";

export default class ReportMiddleware {
  static *GetReports({ payload, cb }) {
    try {
      const {
        limit = 10,
        offset = 0,
        type = "",
        page = 1,
        responded = "",
      } = payload;

      // API call
      let res = yield ApiCaller.Get(
        `/reports?limit=${limit}&responded=${responded}&page=${page}&type=${type}`
      );

      if (res.status === 200) {
        // Assuming actual data is inside `res.data.data`
        const reportsData = res.data || res.data.message; // Adjust this to match your response structure

        // Dispatch success action with the actual data
        yield put(ReportAction.getReportsSuccess(reportsData));

        // Pass the correct data to the callback
        if (cb) {
          cb(reportsData); // Return the data instead of just "Success"
        }
      } else {
        // Handle the error and return null in the callback
        yield put(ReportAction.getReportsFailure(res.data.message));
        if (cb) {
          cb(null);
        }
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      // Catch any errors, dispatch failure action, and return null in the callback
      yield put(ReportAction.getReportsFailure());
      if (cb) {
        cb(null);
      }
    }
  }
}
